import { generateConfig } from './api';

class HeidiService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  }

  /**
   * Get a JWT token for Heidi Health authentication
   * @returns {Promise<string>} JWT token
   */
  async getHeidiToken() {
    try {
      const response = await fetch(`${this.baseUrl}/api/heidi/token`, generateConfig());
      const data = await response.json();
      return data.token;
    } catch (error) {
      console.error('Error getting Heidi token:', error);
      throw error;
    }
  }

  /**
   * Save Heidi analysis results
   * @param {string} clientId - The client ID
   * @param {string} appointmentId - The appointment ID
   * @param {Object} analysisData - The analysis data from Heidi
   * @returns {Promise<Object>} The saved analysis
   */
  async saveHeidiAnalysis(clientId, appointmentId, analysisData) {
    try {
      const response = await fetch(`${this.baseUrl}/api/heidi/analysis`, {
        ...generateConfig(),
        method: 'POST',
        body: JSON.stringify({
          clientId,
          appointmentId,
          analysisData,
        }),
      });
      return response.json();
    } catch (error) {
      console.error('Error saving Heidi analysis:', error);
      throw error;
    }
  }
}

const heidiService = new HeidiService();
export default heidiService; 